
export type cupolaT = {
    label: string,
    value: string,
    imgComponent: any
}
export const listCupola: cupolaT[] = [
    {
        label: '18" Basic Cupola - Black Metal Roof',
        value: 'BlackMetalRoof',
        imgComponent: 'BlaskCupola'
    },
    {
        label: '18" Basic Cupola - Copper Color Roof',
        value: 'CopperColorRoof',
        imgComponent: 'CopperColorRoof'
    },
    {
        label: '22" Deluxe Cupola',
        value: '22DeluxeCupola',
        imgComponent: 'DeluxeCupola'
    },
    {
        label: '30" Deluxe Cupola',
        value: '30DeluxeCupola',
        imgComponent: 'DeluxeCupola'
    },
]